function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C97629"
    },
    d: "M408,32c4.416,0,8-3.584,8-8V8c0-4.416-3.584-8-8-8H104c-4.416,0-8,3.584-8,8v16c0,4.416,3.584,8,8,8 h8v182.16c-0.48,12.648-2.936,25.152-7.28,37.04c-1,3.152-1,6.528,0,9.68c4.336,11.864,6.792,24.336,7.28,36.96V480h-8 c-4.416,0-8,3.584-8,8v16c0,4.416,3.584,8,8,8h304c4.416,0,8-3.584,8-8v-16c0-4.416-3.584-8-8-8h-8V297.84 c0.48-12.648,2.936-25.152,7.28-37.04c1-3.152,1-6.528,0-9.68c-4.336-11.864-6.792-24.336-7.28-36.96V32H408z M384,214.16 c-0.48,12.648-2.936,25.152-7.28,37.04c-1,3.152-1,6.528,0,9.68c4.336,11.864,6.792,24.336,7.28,36.96V480H128V297.84 c0.48-12.648,2.936-25.152,7.28-37.04c1-3.152,1-6.528,0-9.68c-4.336-11.864-6.792-24.336-7.28-36.96V32h256V214.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E7F0"
    },
    d: "M360,152V32H152v120c0.016,39.232,22.104,75.112,57.12,92.8c4,1.88,5.72,6.648,3.84,10.64 c-0.792,1.688-2.152,3.04-3.84,3.84C174.128,276.952,152.04,312.8,152,352v128h208V352c-0.016-39.232-22.104-75.112-57.12-92.8 c-4-1.88-5.72-6.648-3.84-10.64c0.792-1.688,2.152-3.04,3.84-3.84C337.872,227.048,359.96,191.2,360,152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06328"
    },
    d: "M120,496h272c8.84,0,16,7.16,16,16H104C104,503.16,111.16,496,120,496z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6B545"
    },
    d: "M244.56,149.92L168,136v16c0,35.656,21.512,67.776,54.48,81.36 c15.168,5.888,25.256,20.376,25.52,36.64v2h16v-2c0.264-16.264,10.352-30.752,25.52-36.64C322.488,219.776,344,187.656,344,152v-16 l-76.56,13.92C259.872,151.296,252.128,151.296,244.56,149.92z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6B545"
    },
    cx: 256,
    cy: 272,
    r: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B84E"
    },
    d: "M256,344c-4.416,0-8-3.584-8-8v-32c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8v32 C264,340.416,260.416,344,256,344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B84E"
    },
    d: "M344,408v72H168v-72l77.04-28c7.056-2.56,14.784-2.56,21.84,0L344,408z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9D5E3"
    },
    d: "M352,360c-4.416,0-8-3.584-8-8c-0.008-21.632-7.976-42.512-22.4-58.64 c-2.768-3.448-2.216-8.48,1.232-11.248c3.192-2.56,7.808-2.304,10.688,0.608c17.04,19.056,26.464,43.72,26.48,69.28 C360,356.416,356.416,360,352,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F9"
    },
    d: "M175.52,368c4.416,0,8-3.584,8-8c0.008-21.632,7.976-42.512,22.4-58.64 c2.768-3.448,2.216-8.48-1.232-11.248c-3.192-2.56-7.808-2.304-10.688,0.608c-17.04,19.056-26.464,43.72-26.48,69.28 C167.52,364.416,171.104,368,175.52,368z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 352,
    style: {
      fill: "#C9D5E3"
    },
    width: 16,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9D5E3"
    },
    d: "M344.48,32v0.88L344,32H152c0,8.84,7.16,16,16,16h160.48c8.84,0,16,7.16,16,16v86.96 c0,21.68-5.84,44.48-21.84,59.12c-3.112,3.136-3.096,8.208,0.04,11.32c3.136,3.112,8.208,3.096,11.32-0.04 c17.056-19.072,26.488-43.768,26.48-69.36V32H344.48z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F9"
    },
    d: "M176,72L176,72c4.416,0,8,3.584,8,8v64c0,4.416-3.584,8-8,8l0,0c-4.416,0-8-3.584-8-8V80 C168,75.584,171.584,72,176,72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCB5B"
    },
    d: "M176,152c4.416,0,8-3.584,8-8v-5.12L168,136v8C168,148.416,171.584,152,176,152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06328"
    },
    d: "M400,360v120h-8V368C392,363.584,395.584,360,400,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06328"
    },
    d: "M392,16H120c-8.84,0-16,7.16-16,16h8v16c4.416,0,8,3.584,8,8v64c0,4.416,3.584,8,8,8V32h256v16 c4.416,0,8,3.584,8,8v64c0,4.416,3.584,8,8,8V32h8C408,23.16,400.84,16,392,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B06328"
    },
    d: "M128,360v120h-8V368C120,363.584,123.584,360,128,360z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.561609299e974576205f5c3810c59af9.svg";
export { ForwardRef as ReactComponent };